import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-switch-lang';
import { toast } from 'react-toastify';
import chatStorage from './chatStorage';
import TooltipedIconButton from '../../components/buttons/Base/TooltipedIconButton';
import authStorage from '../../storages/mobx/authStorage';
import seven from '../../../../../theme/theme/src/assets/images/user/7.jpg';
import ChangeableImage from '../../components/images/ChangeableImage';
import { API_UPLOAD_FILE } from '../../services/apiPoints';

class ChatControls extends Component {
  addImageDialog = observable({
    opened: false,
    imageLink: null,
  })

  getImageUploadParams = ({ meta }, ...rest) => {
    const jwtToken = localStorage.getItem('token');
    const headers = {};
    if (jwtToken) {
      headers.Authorization = `Bearer ${jwtToken}`;
    }
    return ({
      url: API_UPLOAD_FILE,
      headers,
    });
  }

  handleImageUpload = (req, status, resp) => {
    const { t } = this.props;
    if (status === 'error_upload') {
      switch (req.xhr.status) {
        case 401:
          toast.error(t('Unauthorised'));
          break;
        case 403:
          toast.error(t('Forbidden'));
          break;
        case 415:
          toast.error(t('Unsupported file'));
          break;
        case 500:
          toast.error(t("Can't upload"));
          break;
        default:
          console.log(req, status, resp);
      }
    }
    if (status === 'done') {
      const response = JSON.parse(resp[0].xhr.response);
      if (response && response.link) {
        this.addImageDialog.imageLink = response.link;
        chatStorage.sendImage(response.link, response.type, response.size, response.filename);
        this.addImageDialog.opened = false;
      }
    }
  };

  render() {
    const { t, disabled } = this.props;
    const { conversationStatus } = chatStorage.currentChat;
    return (
      <div className="area-editor flex-config" id="messageInputContainer">
        <div className="chat-area-editor-container flex-config ">
          {this.addImageDialog.opened && (
            <ChangeableImage
              opened={this.addImageDialog.opened}
              toggle={() => { this.addImageDialog.opened = !this.addImageDialog.opened; }}
              // onSave={authStorage.saveProfile}
              getUploadParams={this.getImageUploadParams}
              handleUpload={this.handleImageUpload}
              cancelText={t('Close')}
              saveText={t('Save')}
              image={this.addImageDialog.imageLink}
            />
          )}
          <div className="flex-row justify-content-between align-items-center">
            <div className="chat-area-editor_icons">
              {/* <TooltipedIconButton */}
              {/*  text="Actions" */}
              {/*  onClick={() => {}} */}
              {/*  id="send-menu" */}
              {/*  className="btn btn-outline" */}
              {/*  icon="fa fa-2x fa-ellipsis-v" */}
              {/* /> */}
              {conversationStatus > 0 && (
                <TooltipedIconButton
                  text="Send file"
                  onClick={() => this.addImageDialog.opened = !this.addImageDialog.opened}
                  id="send-file"
                  className="btn btn-outline"
                  icon="fa fa-2x fa-file-image-o"
                />
              )}
              {/* <TooltipedIconButton */}
              {/*  text="Send file" */}
              {/*  onClick={() => {}} */}
              {/*  id="send-file" */}
              {/*  className="btn btn-outline" */}
              {/*  icon="fa fa-2x fa-smile-o" */}
              {/* /> */}
            </div>

            <div className="chat-area-editor-input">
              <textarea
                type="text"
                id="message"
                disabled={disabled || conversationStatus <= 0}
                placeholder={
                  conversationStatus <= 0 ? t('User unsubscribed') : t('Type your message here')
                }
                value={chatStorage.currentMessages[chatStorage.currentChatID]}
                style={{ width: '100%', resize: 'none' }}
                spellCheck
                onKeyPress={
                  this.onMessageKeyPress
                }
                onInput={(e) => chatStorage.changeCurrentMessage(e.target.value)}
              />
              <div id="message_div" />
            </div>

            <div className="flex-row">
              {/* <div className="chat-area-editor_icons"><i className="fa fa-smile-beam" /></div> */}
              {!disabled && (
                <div className="chat-area-editor_icons" onClick={() => (conversationStatus < 0 ? toast.error(t('User unsubscribed')) : chatStorage.sendMessage())}>
                  <i className="fa  fa-2x fa-arrow-right" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  onMessageKeyPress =
    (e) => {
      if (e.code == 'Enter' && e.shiftKey == false && e.altKey == false && e.ctrlKey == true) {
        e.stopPropagation();
        e.preventDefault();
        chatStorage.sendMessage();
        return;
      }
      const min_line_count = 2;
      const line_height = 18;
      const min_line_height = min_line_count * line_height;
      const max_height = window.innerHeight / 3;
      const obj = e.target;
      const div = document.getElementById(`${obj.id}_div`);
      div.innerHTML = chatStorage.currentMessages[chatStorage.currentChatID] + e.key;
      let obj_height = div.offsetHeight;
      if (e.code == 'Enter' && e.shiftKey == false && e.altKey == false && e.ctrlKey == false) {
      //   // e.stopPropagation();
      //   // e.preventDefault();
        obj_height += line_height;
      }
      if (obj_height < min_line_height) {
        obj_height = min_line_height;
      }
      if (obj_height > max_height) obj_height = max_height;
      obj.style.height = `${obj_height}px`;
    }
}

ChatControls.defaultProps = {
  disabled: false,
};

ChatControls.propTypes = {
  disabled: PropTypes.bool,
};

export default translate(observer(ChatControls));
